import Vue from 'vue'
import Child from './Child'

import SelectExtended from './form/SelectExtended'
import TableExtended from './TableExtended'
import VField from './form/VField'
import VHasMany from './form/VHasMany'
import VCheckbox from './form/VCheckbox'
import VDisplay from './form/VDisplay'
import VDiff from './form/VDiff'
import VInput from './form/VInput'
import VFile from './form/VFile'
import VSelect from './form/VSelect'
import VRadio from './form/VRadio'
import VRadioButtons from './form/VRadioButtons'
import VCoords from './form/VCoords'
import VDatetime from './form/VDatetime'
import VAutocomplete from './form/VAutocomplete'
import VAutocompleteList from './form/VAutocompleteList'
import VButton from './form/VButton'
import VSubmit from './form/VSubmit'
import VWyswyg from './form/VWyswyg'
import SpinnerIqos from './spinner/Spinner-Iqos'
import Page from './Page'
import Card from './Card'
import Tabs from './Tabs'
import Alert from './Alert'
import List from './List'
import Header from './Header'
import ChartWidget from './ChartWidget'
import VTable from './Table'
import VDatetimePicker from "./form/VDatetimePicker";
import VChip from './form/VChip.vue';

// Components that are registered globaly.
[
    SelectExtended,
    TableExtended,
    VField,
    VHasMany,
    VCheckbox,
    VDisplay,
    VDiff,
    VInput,
    VFile,
    VSelect,
    VRadio,
    VRadioButtons,
    VCoords,
    VDatetime,
    VAutocomplete,
    VAutocompleteList,
    VButton,
    VSubmit,
    VWyswyg,
    SpinnerIqos,
    Page,
    Card,
    Tabs,
    Alert,
    List,
    Header,
    Child,
    ChartWidget,
    VTable,
    VDatetimePicker,
    VChip
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js